import React, { useCallback, useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { cart_list, passDiscountCartAPI, remove_cart, update_cart } from "../../../../../Studio-Services/Studio_Services";
import { useEffect } from "react";
import Swal from "sweetalert2";
import logo from "../../../../../Images/logo_white_web.png"
import { SharedButton } from "../../../../../sharedComponents/Button";
import "./CartTable.css"
import { errorAlert } from "../../../../../Static_Services/Alertmsg";
import { InputField } from "../../../../../sharedComponents/InputField";

export const CartTable = ({ client_id, setLoder }) => {
  const [tableData, setTableData] = useState([]);
  const [tableDataCart, setTableDataCart] = useState([]);
  const [clientId, setClientId] = useState();
  const [cartNo, setCartNo] = useState(0);
  const [totalBaseAmount, setTotalBaseAmount] = useState(0);

  const [tablePrice, setTablePrice] = useState([]);
  const [showCodeModel, setShowCodeModel] = useState({ visible: false, codeData: [], itemData: '' });




  const adjAmount = (amount, discount, quantity) => {
    const calculate = amount * quantity;
    const adjAmount = calculate - parseFloat(discount);
    return parseFloat(adjAmount);
  };

  const adjAmountSubTotal = (amount, discount, tax, qty) => {
    const baseAmt = amount * qty;
    console.log("amount--", amount, '-discount--', discount, "--tax--", tax, "--qty--", qty);
    const amt = (baseAmt - parseFloat(discount)) + parseFloat(tax);
    return parseFloat(amt);
  };

  const adjAmountSubTotalNew = (amount, discount, qty, tax1, tax2) => {
    const totalTax = parseFloat(tax1) + parseFloat(tax2);
    const baseAmt = amount * qty;
    const amt = (baseAmt - parseFloat(discount)) + parseFloat(totalTax);
    return parseFloat(amt);
  };


  const getCartItem = async (noLoader = false) => {
    if (!noLoader) { setLoder(true); }
    const fData = {
      pageid: "1",
      client_id: client_id,
    };
    const resp = await cart_list(fData);
    if (resp) {
      setLoder(false);
      setTableData(resp.data.data);
      setTableDataCart(resp.data.data.business_details.cart_details);
      const newCatDetails = resp?.data?.data?.business_details?.cart_details;
      let newCartArray = [];
      newCatDetails.map((e) => (
        newCartArray.push({
          "cartID": e?.cart_id,
          "BaseAmount": parseFloat(e.base_amount),
          "Quantity": e?.quantity,
          "Price": parseFloat((e.amount * e.quantity)),
          "Discount": e.discount,
          "AdjPrice": adjAmount(e.amount, e.discount, e.quantity),
          "Tax1": parseFloat(e.tax1_rate),
          "Tax2": parseFloat(e.tax2_rate),
          "SubTotal": adjAmountSubTotalNew(e.amount, e.discount, e.quantity, e.tax1_rate, e.tax2_rate),
        })
      ));

      setTablePrice(newCartArray);

      if (resp && resp.data && resp.data.data && resp.data.data.business_details && resp.data.data.business_details.cart_details) {
        const cartArray = resp.data.data.business_details.cart_details;
        let cartno = 0;
        let totalAmount = 0;
        cartArray.forEach(e => {
          cartno += parseInt(e.quantity, 10);
          totalAmount += parseFloat(e.base_amount);
        });
        setCartNo(cartno);
        setTotalBaseAmount(totalAmount.toFixed(2));
      }


    } else {
      setTableData([]);
      setTableDataCart([]);
      setLoder(false);
    }
  };

  useEffect(() => {
    if (client_id) {
      getCartItem();
      setClientId(client_id);
    }
  }, [client_id]);

  const addQuintity = async (data, index) => {
    setLoder(true);
    const quint = data + 1;
    var Quantity = tableData.business_details.cart_details[index];
    const fData = {
      "product_id": Quantity.service_id,
      "quantity": quint,
      "client_id": clientId,
      "cart_id": Quantity.cart_id,
      "business_id": localStorage.getItem("business_id"),
      "discount": Quantity.discount,
    }
    const resp = await update_cart(fData);
    if (resp) {
      getCartItem();
    } else {
      setLoder(false);
    }
  }

  const remQuintity = async (data, index) => {
    setLoder(true);
    if (data == 1) {
      setLoder(false);
      return
    } else {
      const quint = data - 1;
      var Quantity = tableData.business_details.cart_details[index];

      const finalAmount = Quantity.amount * quint;
      const discount = Quantity.discount;

      if (discount >= finalAmount) {
        errorAlert('Discounted should be less than total amount.');
        setLoder(false);
        return;
      }

      const fData = {
        "product_id": Quantity.service_id,
        "quantity": quint,
        "client_id": clientId,
        "cart_id": Quantity.cart_id,
        "business_id": localStorage.getItem("business_id"),
        "discount": Quantity.discount,
      }
      const resp = await update_cart(fData);
      if (resp) {
        getCartItem();
        Swal.fire({
          html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
        <h4 class="title text-capitalize text-center mt-4 textWhite">
      SUCCESS
      </h4>
      <p class="text-center my-4 textcolor">
      <small class="textWhite">
     ${resp.data.message} </small></p>
      `,
          showClass: {
            popup: 'custom-dialog-container',
          },
          customClass: {
            confirmButton: 'custom-button custom-button-size modalbtn',
          },
        });
      } else {
        setLoder(false);
      }
    }
  }

  const removeCart = async (cart_type, data) => {

    var request = {
      remove_cart_type: cart_type,
      cart_id: data.cart_id,
      client_id: clientId,
    };
    const resp = await remove_cart(request);
    if (resp) {
      getCartItem();
      Swal.fire({
        html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
      <h4 class="title text-capitalize text-center mt-4 textWhite">
      SUCCESS
    </h4>
    <p class="text-center my-4 textcolor">
    <small class="textWhite">
   ${resp.data.message} </small></p>
    `,
        showClass: {
          popup: 'custom-dialog-container',
        },
        customClass: {
          confirmButton: 'custom-button custom-button-size modalbtn',
        },
      });
    } else {
      getCartItem();
      setLoder(false);
    }
  }

  const updateItem = async (data) => {
    const final = (data.amount) * (data.quantity);
    const dis = data.discount;

    // console.log("final----  ", final);
    // console.log("dis---  ", dis);

    if (final <= dis) { errorAlert('Discounted should be less than total amount.'); return; }
    setLoder(true);
    var request = {
      product_id: data.service_id,
      quantity: data.quantity,
      client_id: clientId,
      cart_id: data.cart_id,
      business_id: localStorage.getItem("business_id"),
      discount: dis,
    };

    const resp = await update_cart(request);
    if (resp) {
      getCartItem();
      Swal.fire({
        html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
      <h4 class="title text-capitalize text-center mt-4 textWhite">
      SUCCESS
    </h4>
    <p class="text-center my-4 textcolor">
    <small class="textWhite">
   ${resp.data.message} </small></p>
    `,
        showClass: {
          popup: 'custom-dialog-container',
        },
        customClass: {
          confirmButton: 'custom-button custom-button-size modalbtn',
        },
      });
    } else {
      getCartItem();
      setLoder(false);
    }
  }


  const ApplyDiscountUpdateItem = useCallback(async (codeData, data) => {

    if (data?.service_type) {
      let final = 0;
      if (codeData?.is_single_use === 'No') {
        final = (data.amount) * (data.quantity);
      } else {
        final = (data.amount);
      }
      const amount = Number(final || 0);
      const percentage = Number(codeData?.amount || 0);
      const dis = ((amount * percentage) / 100).toFixed(2);

      const totalAmount = Number(final);
      const discountAmount = Number(dis);

      if (totalAmount <= discountAmount) { errorAlert('Discounted should be less than total amount.'); return; }
      setLoder(true);
      setShowCodeModel({
        visible: false, codeData: [], itemData: ''
      });
      var request = {
        'product_id': data.service_id,
        'quantity': data.quantity,
        'client_id': clientId,
        'cart_id': data.cart_id,
        'business_id': localStorage.getItem("business_id"),
        'discount': dis,
        'discount_code_id': codeData?.discount_code_id,
        'discount_code_name': codeData?.code_name,
        'service_type': parseInt(data?.service_type),
      };
      try {
        let resp = '';
        if (parseInt(data?.service_type) === 3) {
          resp = await update_cart(request);
        } else {
          resp = await passDiscountCartAPI(request);
        }

        if (resp) {
          getCartItem(true);
          setLoder(false);

          Swal.fire({
            html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                   <h4 class="title text-capitalize text-center mt-4 textWhite">
                      SUCCESS
                              </h4>
                              <p class="text-center my-4 textcolor">
                              <small class="textWhite">
                              ${"The discount has been applied successfully"} </small></p>
                              `,
            showClass: {
              popup: 'custom-dialog-container',
            },
            customClass: {
              confirmButton: 'custom-button custom-button-size modalbtn',
            },
          });
          // Swal.fire({
          //   html: `
          //    <div>
          //     <img src="assets/gif/congratulation.gif" width="100%" />
          //     <h4 style="color:#00ff99;
          //      position: absolute;
          //     top: 68%;
          //     left:0;
          //     right:0;
          //       font-weight:700;
          //     ">COUPON APPLIED!</h4>
          //     <p style="color:#fff;
          //     position: absolute;
          //     top: 80%;
          //     left:0;
          //     right:0;
          //     font-weight:700;
          //     ">You saved ₹${discountAmount}</p>
          //   </div>            
          // `,
          //   background: 'none',
          //   showConfirmButton: false,
          //   timer: 3000,
          //   showClass: {
          //     popup: 'animate__animated animate__bounceIn'
          //   }
          // });
        } else {
          getCartItem();
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoder(false);
      }

    }
  }, [clientId])

  const dischangeHandler = (data, ind, fullData) => {

    const sub_total = fullData?.sub_total || 0;
    const disc = data.target.value;

    if (parseFloat(disc) > parseFloat(sub_total)) { errorAlert('Discounted should be less than total amount.'); return; }

    let sData = [...tableDataCart];


    // if (sData[ind].discount > sData[ind].amount) {
    //   sData[ind].discount = 0;
    // } else {
    //   sData[ind].discount = disc;
    //   setTableDataCart(sData);
    // }

    const baseAmt = parseFloat(sData[ind].amount) * parseInt(sData[ind].quantity);
    if (parseFloat(disc) > baseAmt) {
      sData[ind].discount = 0.00;
    } else {
      sData[ind].discount = disc;
    }
    setTableDataCart(sData);
  }

  const [dCode, setDCode] = useState({});




  const handleApply = (discountList, item, code_name) => {
    const codeValue = dCode[item.cart_id] || code_name;
    if (!codeValue) {
      errorAlert("Please enter discount code");
      return;
    }
    const found = (discountList || []).find(
      (d) =>
        d.code_name.toLowerCase().trim() ===
        codeValue.toLowerCase().trim()
    );
    if (found) {
      ApplyDiscountUpdateItem(found, item);
    } else {
      errorAlert("Invalid Discount Code");
    }
  };


  return (
    <>
      {tableDataCart.length > 0 ?
        <div className="CardTable" style={{ marginTop: "20px" }}>
          <table className="table table-striped table-responsive p-2">
            <thead>
              <tr>
                <th scope="col">Product Name</th>
                <th scope="col">Base Amount</th>
                <th scope="col">Quantity</th>
                <th scope="col">Price</th>
                <th scope="col">Discount (In $)</th>
                <th scope="col">Adj Price (In $)</th>
                <th scope="col">Tax1</th>
                <th scope="col">Tax2</th>
                <th scope="col">Discount Code</th>
                <th scope="col">Sub Total</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {tableDataCart ?
                (tableDataCart).map((e, index) => (
                  <tr key={index}>
                    <td>
                      <div className="tableimg">
                        <img src={e.item_image ? e.item_image : "assets/images/passes.png"} alt="" width="50" height="50" /><p>{e.item_name}</p>
                      </div>
                    </td>
                    <td>{`$ ${parseFloat(e.base_amount).toFixed(2)}`}</td>
                    {(e.service_type) === "3" ?
                      <td>
                        <div className="incrementdecrement" style={{ padding: '0px 5px' }}>
                          <button className="incrementBtn" onClick={() => addQuintity(e.quantity, index)}>+</button><span>{e.quantity}</span><button className="incrementBtn" onClick={() => remQuintity(e.quantity, index)}>-</button>
                        </div>
                      </td>
                      :
                      <td>{e.quantity}</td>
                    }
                    <td>{`$ ${parseFloat((e.amount * e.quantity).toFixed(2))}`}</td>
                    {(e.service_type) === "3" ?
                      <td>
                        <div className="inputNumber">
                          <input type="number"
                            style={{ padding: '0.1rem 0.4rem' }}
                            step=".01"
                            min="0"
                            max={e.quantity}
                            onChange={(element) => dischangeHandler(element, index, e)}
                            value={e.discount}
                          />
                        </div>
                      </td>
                      :
                      <td>{`$ ${e.discount}`}</td>
                    }
                    <td>{`$ ${adjAmount(e.amount, e.discount, e.quantity).toFixed(2)}`}</td>
                    <td>{`$ ${parseFloat(e.tax1_rate).toFixed(2)}`}</td>
                    <td>{`$ ${parseFloat(e.tax2_rate).toFixed(2)}`}</td>
                    <td>{
                      <div className="discount-box">
                        <div className="inputNumber" style={{ padding: '0px 10px' }}>
                          <input
                            type="text" style={{ width: '150px', padding: '0.1rem 0.4rem', fontSize: '12px' }}
                            placeholder="discount code"
                            // value={dCode ? dCode : e?.discount_code_name}
                            // onChange={(item) => { setDCode(item?.target?.value); }}
                            value={dCode[e.cart_id] ?? e?.discount_code_name ?? ""}
                            onChange={(event) =>
                              setDCode((prev) => ({
                                ...prev,
                                [e.cart_id]: event.target.value
                              }))
                            }
                          />
                        </div>
                        <button
                          className="discount-button"
                          onClick={() => handleApply(e.discount_code, e, e?.discount_code_name)}
                        >
                          Apply
                        </button>
                      </div>
                    }</td>
                    <td>{`$ ${adjAmountSubTotalNew(e.amount, e.discount, e.quantity, e.tax1_rate, e.tax2_rate).toFixed(2)}`}</td>
                    {(e.service_type) === "3" ?
                      <td>
                        <div className="updateRemove">
                          <button onClick={() => updateItem(e)}>Update</button> | <button onClick={() => removeCart(0, e)}>Remove</button>
                        </div>
                      </td>
                      :
                      <td>
                        <div className="updateRemove text-center">
                          <button onClick={() => removeCart(0, e)}>Remove</button>
                        </div>
                      </td>
                    }
                  </tr>
                ))
                : ""}
              <tr>

                <td>
                  <h6>Total</h6>
                </td>
                <td>{`$ ${totalBaseAmount}`}</td>
                <td>{cartNo}</td>
                <td>{`$ ${tableData && tableData.total_amount ? parseFloat(tableData.total_amount).toFixed(2) : ""}`}</td>
                <td>{`$ ${tableData ? parseFloat(tableData.total_discount).toFixed(2) : ""}`}</td>
                <td>{`$ ${tableData && tableData.total_amount ? parseFloat(parseFloat(tableData.total_amount) - parseFloat(tableData.total_discount)).toFixed(2) : ""}`}</td>
                <td>{`$ ${tableData ? parseFloat(tableData.tax1_rate).toFixed(2) : ""}`}</td>
                <td>{`$ ${tableData ? parseFloat(tableData.tax2_rate).toFixed(2) : ""}`}</td>
                <td>{`$ ${tableData && tableData.grand_total ? parseFloat(tableData.grand_total).toFixed(2) : "0.00"}`}</td>

                <td>
                  <SharedButton
                    title={"Checkout"}
                    className={"btn w-100 text-capitalize"}
                    type={"button"}
                    href={"/Payment"}
                    element={{ data: tableData, client_id: clientId, priceData: tablePrice }}
                    variant="primary"
                  />
                </td>

              </tr>
            </tbody>
          </table>
        </div>
        :
        <Row style={{ textAlign: "center" }}>
          <Col>
            <h2>No Record</h2>
          </Col>
        </Row>
      }


      <Modal
        show={showCodeModel.visible}
        onHide={() => { setShowCodeModel({ visible: false, codeData: [], itemData: '' }) }}
        backdrop="static"
        centered
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Coupons Codes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showCodeModel?.codeData?.length > 0 ?
            (showCodeModel?.codeData ?? []).map((item, index) => (
              <div className="row discount_model_row" key={index}>
                <div className="col-md-9 m-auto">
                  <p className="m-0 p-0"> {item?.code_name}</p>
                </div>
                <div className="col-md-3  m-auto model_button_box">
                  <button
                    className="discount-button"
                    onClick={() => { ApplyDiscountUpdateItem(item, showCodeModel?.itemData) }}
                  >Apply</button>
                </div>
              </div>
            ))
            :
            <div className="row discount_model_row">
              <div className="col-md-12 discount-box">
                <p className="m-0 p-0"> No Coupon Available</p>
              </div>
            </div>
          }
        </Modal.Body>

      </Modal >

    </>
  );
};
